import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const LoginModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "LoginModalContainer" */
      './LoginModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
